import React from 'react'
import { Flex, Box, Image, Grid } from '@chatterbug/aaron'
import LanguageFlags from 'src/ui/LanguageFlags/LanguageFlags'
import RankingNumber from '../RankingNumber/RankingNumber'
import UserLogin from '../UserLogin/UserLogin'
import { Language, LeaderboardUser } from 'src/types'
import { t } from 'src/lib/i18n-react'

const interactionStyles = {
  ':hover': {
    color: 'blue42',
    cursor: 'pointer',
    textDecoration: 'none',
  },
  ':active': {
    color: 'blue30',
  },
}

export type Props = {
  user: LeaderboardUser
  rank: number
  languages: Language[]
  studyTime: number
  isCurrentUser?: boolean
}

const LeaderboardRow: React.FC<Props> = ({
  user,
  rank,
  languages,
  studyTime,
  isCurrentUser,
}) => {
  return (
    <Grid
      mb={isCurrentUser ? 0 : '2x'}
      columns={{
        _: '24px 32px 1fr auto 80px',
        tablet: '24px 32px 1fr auto minmax(80px, auto)',
      }}
      gridGap="1x"
      alignItems="center"
      data-testid="ranked-user"
    >
      <RankingNumber ranking={rank} showBlueBackground={isCurrentUser} />
      <Box sx={{ height: 32, width: 32, overflow: 'hidden', borderRadius: '100%' }}>
        <Image src={user?.avatarUrl} alt="" />
      </Box>
      <UserLogin login={user?.login} interactionStyles={interactionStyles} />
      {languages && (
        <Box>
          <LanguageFlags languages={languages.map((l) => l.code)} />
        </Box>
      )}
      <Box as="p" variant="text.paragraph" textAlign="right">
        {t('%{smart_count} hour |||| %{smart_count} hours', {
          smart_count: studyTime,
        })}
      </Box>
    </Grid>
  )
}

export default LeaderboardRow
